import * as React from "react";
import { Provider } from "react-redux";
import { useLocation, useFormatter } from "@grandvisionhq/frk-routing";
import { contextKey } from "./Saga/Saga/routing.js";
const ReduxProvider = ({
  store,
  children,
  ...rest
}) => {
  const { replace, push } = useLocation();
  const format = useFormatter();
  React.useEffect(() => {
    const context = {
      replace,
      push,
      format
    };
    store.setSagaContext({ [contextKey]: context });
  }, [store, format, replace, push]);
  return /* @__PURE__ */ React.createElement(Provider, { ...rest, store }, children);
};
export {
  ReduxProvider
};
//# sourceMappingURL=provider.js.map
